import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

export default props => (
  <section className="contact-thirds" id="contact">
    <div className="container">
      <div className="row">
        <div className="col-sm-12 text-center">
          <h1>
            Skontaktuj się z nami!<br />
          </h1>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <h5>Jak do nas dotrzeć?</h5>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <p className="lead ">
                <strong>Telefon: </strong>+48 512 333 494<br />
                <strong>Email: </strong>marek@twojabi.net<br />
              </p>
            </div>
            <div className="col-sm-12 col-md-6 mb-3">
              <p className="lead">
                <strong>Ulica: </strong>Zamkowa 30,<br />
                <strong>Miejscowość: </strong>47-451 Tworków
              </p>
            </div>
          </div>
          <Map
            isMarkerShown
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDIKeMfh0L55ulBV3GcDFWcd7j0fu0rOT4&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: '100%' }} />}
            containerElement={<div style={{ height: '410px' }} />}
            mapElement={<div style={{ height: '100%' }} />}
          />
        </div>

        <div className="col-sm-6">
          <h5>Zostaw wiadomość</h5>
          <p className="lead mb-3">Napisz z czym masz problem. Odezwiemy się wkrótce żeby pomóc Ci go rozwiązać.</p>
          <div className="form-wrapper clearfix">
            <form
              className="form-contact email-form"
              name="contact"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              method="post"
            >
              <input type="hidden" name="form-name" value="contact" />
              <div className="inputs-wrapper">
                <input className="form-name validate-required" type="text" placeholder="Imię" name="name" required />
                <input
                  className="form-name validate-required"
                  type="text"
                  placeholder="Nazwisko"
                  name="surname"
                  required
                />
                <input
                  className="form-email validate-required validate-email"
                  type="text"
                  placeholder="Email"
                  name="email"
                  required
                />
                <textarea
                  className="form-message validate-required"
                  name="message"
                  placeholder="Twoja wiadomość"
                  rows="4"
                  required
                />
              </div>
              <input
                type="hidden"
                name="permission"
                value="Użytkownik wyraził zgodę na przetwarzanie danych w celu kontaktu poprzez zaznaczenie odpowiedniej opcji w formularzu."
              />
              <div style={{ marginBottom: 15 }}>
                <input
                  type="checkbox"
                  id="privacy-policy"
                  required
                  style={{ width: '35px', margin: 0, verticalAlign: 'middle' }}
                />
                <label htmlFor="privacy-policy" style={{ margin: 0 }}>
                  Zgadzam się z <a href="/polityka-prywatnosci">polityką prywatności</a>
                </label>
              </div>
              <input type="submit" className="send-form" value="Wyślij" />
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const styleMap = [
  {
    featureType: 'landscape',
    stylers: [{ hue: '#FFBB00' }, { saturation: 43.400000000000006 }, { lightness: 37.599999999999994 }, { gamma: 1 }],
  },
  {
    featureType: 'road.highway',
    stylers: [{ hue: '#FFC200' }, { saturation: -61.8 }, { lightness: 45.599999999999994 }, { gamma: 1 }],
  },
  {
    featureType: 'road.arterial',
    stylers: [{ hue: '#FF0300' }, { saturation: -100 }, { lightness: 51.19999999999999 }, { gamma: 1 }],
  },
  {
    featureType: 'road.local',
    stylers: [{ hue: '#FF0300' }, { saturation: -100 }, { lightness: 52 }, { gamma: 1 }],
  },
  {
    featureType: 'water',
    stylers: [{ hue: '#0078FF' }, { saturation: -13.200000000000003 }, { lightness: 2.4000000000000057 }, { gamma: 1 }],
  },
  {
    featureType: 'poi',
    stylers: [{ hue: '#00FF6A' }, { saturation: -1.0989010989011234 }, { lightness: 11.200000000000017 }, { gamma: 1 }],
  },
];

const Map = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={11}
      defaultCenter={{ lat: 50.007454, lng: 18.237748 }}
      // defaultOptions={{ disableDefaultUI: true, styles: styleMap }}
    >
      {props.isMarkerShown && <Marker title="RODO" position={{ lat: 50.007454, lng: 18.237748 }} />}
    </GoogleMap>
  )),
);



// WEBPACK FOOTER //
// ./src/components/Contact.js